import { useState } from 'react';
import { ChartOfAccountsTab } from '../components/ChartOfAccountsTab';
import { FinancialYearSettings } from '../components/FinancialYearSettings';
import { ProductCatalogTab } from '../components/ProductCatalogTab';

const TABS = [
  { id: 'coa', label: 'Chart of Accounts' },
  { id: 'catalog', label: 'Products & Services' },
  { id: 'fy', label: 'Financial Years' },
];

export function AccountsSettingsPage() {
  const [tab, setTab] = useState('coa');
  return (
    <div className="p-6 space-y-4">
      <div><h1 className="text-2xl font-semibold tracking-tight">Accounting Settings</h1><p className="text-sm text-muted-foreground mt-1">Chart of accounts, product catalog and financial year management</p></div>
      <div className="flex gap-2 border-b">
        {TABS.map(t => (<button key={t.id} onClick={() => setTab(t.id)} className={`px-4 py-2 text-sm font-medium border-b-2 transition ${tab === t.id ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>{t.label}</button>))}
      </div>
      {tab === 'coa' && <ChartOfAccountsTab />}
      {tab === 'catalog' && <ProductCatalogTab />}
      {tab === 'fy' && <FinancialYearSettings />}
    </div>
  );
}
